import googleTagManager from '@analytics/google-tag-manager';
import { Analytics as defaultAnalytics, AnalyticsInstance } from 'analytics';

import { consentManagerPlugin } from '../../cookieStore/plugins/consentManagerPlugin';
import { iframePlugin } from '../../trackingPixelStore/plugins/iframePlugin';
import { imagePlugin } from '../../trackingPixelStore/plugins/imagePlugin';
import { tradeDeskPlugin } from '../../trackingPixelStore/plugins/tradeDeskPlugin';
import { yahooDotPlugin } from '../../trackingPixelStore/plugins/yahooDotPlugin';
import { analyticAuth } from '../constants/analyticAuth';

export const createAnalyticsInstance = (
  Analytics = defaultAnalytics,
): AnalyticsInstance => {
  const currentEnvironment: string = import.meta.env
    .VITE_APP_TARGET_ENVIRONMENT;

  // Return a no-op analytics instance if environment is not configured
  if (!(currentEnvironment in analyticAuth)) {
    return Analytics(null);
  }

  const { googleTagManagerAuth } = analyticAuth[currentEnvironment];

  return Analytics({
    app: 'consumer-portal',
    plugins: [
      // holds every plugin below until the consent manager has loaded (see cookieStore/README.md)
      consentManagerPlugin(),
      googleTagManager(googleTagManagerAuth),
      iframePlugin(),
      imagePlugin(),
      tradeDeskPlugin(),
      yahooDotPlugin(),
    ],
  });
};
